import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../utils/auth';
import ThemeToggle from './ThemeToggle';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    auth.logout();
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '[H]' },
    { path: '/calendar', label: 'Kalender', icon: '[#]' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => navigate('/dashboard')}>
          <div className="navbar-logo">
            <div className="pixel-heart">♥</div>
          </div>
          <span className="navbar-title">NUVIA</span>
        </div>

        <div className="navbar-menu">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`navbar-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className="navbar-item-icon">{item.icon}</span>
              <span className="navbar-item-label">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="navbar-actions">
          <ThemeToggle />
          <button className="navbar-logout" onClick={handleLogout}>
            <span className="logout-icon">✕</span>
            <span className="logout-label">Logout</span>
          </button>
        </div>
      </div>

      {/* Pixel scanline effect */}
      <div className="navbar-scanline"></div>
    </nav>
  );
}

export default Navbar;
